class FoamSlotShopCatalog extends HTMLElement {
  connectedCallback() {
    this.search = this.querySelector('[data-shop-search]');
    this.buttons = Array.from(this.querySelectorAll('[data-shop-filter-group]'));
    this.cards = Array.from(this.querySelectorAll('[data-shop-card]'));
    this.count = this.querySelector('[data-shop-count]');
    this.activeFilters = { series: 'all', material: 'all' };
    const params = new URLSearchParams(window.location.search);
    const initialQuery = (params.get('q') || '').trim();
    if (this.search && initialQuery) this.search.value = initialQuery;
    ['series', 'material'].forEach((group) => {
      const requested = (params.get(group) || '').trim();
      const matchingButton = this.buttons.find((button) => button.dataset.shopFilterGroup === group && button.dataset.shopFilter === requested);
      if (matchingButton) this.activeFilters[group] = requested;
    });
    this.syncFilterButtons();
    this.search?.addEventListener('input', () => this.update());
    this.buttons.forEach((button) => button.addEventListener('click', () => {
      const group = button.dataset.shopFilterGroup;
      this.activeFilters[group] = button.dataset.shopFilter || 'all';
      this.syncFilterButtons();
      this.update();
    }));
    this.update();
  }

  syncFilterButtons() {
    this.buttons.forEach((button) => {
      const group = button.dataset.shopFilterGroup;
      button.setAttribute('aria-pressed', String(this.activeFilters[group] === (button.dataset.shopFilter || 'all')));
    });
  }

  update() {
    const query = (this.search?.value || '').trim().toLowerCase();
    let visible = 0;
    this.cards.forEach((card) => {
      const searchMatch = !query || (card.dataset.search || '').includes(query);
      const seriesMatch = this.activeFilters.series === 'all' || (card.dataset.series || '').split(' ').includes(this.activeFilters.series);
      const materialMatch = this.activeFilters.material === 'all' || card.dataset.material === this.activeFilters.material;
      const show = searchMatch && seriesMatch && materialMatch;
      card.hidden = !show;
      if (show) visible += 1;
    });
    this.dataset.empty = String(visible === 0);
    if (this.count) this.count.textContent = `${visible} ${visible === 1 ? this.count.dataset.singular : this.count.dataset.plural}`;
  }
}

if (!customElements.get('foamslot-shop-catalog')) customElements.define('foamslot-shop-catalog', FoamSlotShopCatalog);
